import React from 'react'
import Layout from '../../components/Layout'

const ModelsPage = () => {
    return (
        <React.Fragment>
            ModelsPage
        </React.Fragment>
    )
}

export default ModelsPage
